<template>
  <transition name="slide-fade">
    <div id="aboutusHolder">
      <!--<div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
        <div class="uk-container uk-container-small">
          <p class="uk-text-center uk-text-lead@l uk-text-large@l">
            <i>"Meeting the world in One Place"</i>
          </p>
        </div>
      </div>-->
      <div class="uk-padding">
        <h1 class="uk-heading-line specHeading uk-text-center"><span>Digital Education Centre</span></h1>
        <div class="uk-container uk-container-small">
          <div class="uk-child-width-1-1@m" uk-grid>

            <div>
              <p class="">
                Digital Education is a formal educational process in which the majority of the instruction
                (interaction between students and facilitators and among students) in a course occurs
                when students and facilitators are not in the same place. Instruction may be
                synchronous or asynchronous. A digital education course may employ
                correspondence study, or audio, or video, or computer technologies. NCU employs all of
                these technologies in course delivery. Utilization of the various formats for digital
                education (e.g., correspondence courses, tele-courses and internet-based courses)
                allows the university to be all-inclusive in its outreach to current and potential students.
              </p>


            </div>

          </div>
          <div class="uk-child-width-1-2@m" uk-grid>
            <div>
              <ul class="uk-list uk-list-bullet ">
                The Digital Education Department shall, therefore, seek to do the following to proactively: <br>
                <li class="uk-text-small">Address changes in the marketplace while satisfying its clientele.</li>
                <li class="uk-text-small">Provide online learning opportunities that will result in certificates, diplomas and
                  degrees being awarded.</li>

                <li class="uk-text-small">Increase enrollment through satellite/extension sites.</li>
                <li class="uk-text-small">Improve online diversification of programming to satellite and online students.</li>

                <li class="uk-text-small">Maintain a high standard of online delivery that will ensure graduates being recognized
                  as educated citizens in society.</li>
              </ul>
            </div>
            <div class="uk-visible@m">
              <img class="uk-align-center" src="../assets/online6.jpg" alt="">
            </div>
          </div>
          <div class="uk-child-width-1-1">
            <div>
              <ul class="uk-list uk-list-bullet ">
                <br>
                <li class="uk-text-small">Ensure that graduates acquire the skills and competencies necessary to perform
                  effectively and efficiently in various environments.</li>

                <li class="uk-text-small">Facilitate professional development courses and programmes online that are relevant
                  and distinctive for the up-skilling of communities.</li>
                <li class="uk-text-small">Improve content delivery via technology innovation.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-padding uk-background-muted">

        <div class="uk-container uk-container-small">
          <div class="uk-child-width-1-2@m" uk-grid>

            <div>
              <h2 class="uk-heading-bullet specHeading "><span>Why NCU for my online education</span></h2>
              <p class=" ">
                Studying through Digital Education at Northern Caribbean University offers the option of
                receiving a Christ-centred education that allows you to fit it around work, social lifestyle and
                family commitments. The convenience of achieving your personal and professional goals
                without having to leave your job, geographical location, friends and family to attend classes on

                campus. One third (1/3) of the contact hours will be delivered synchronously and the
                remainder will be delivered asynchronously, which will allow you to study at your own pace.
                The Digital Education team will ensure that you receive full support from the system, your
                facilitator and the course coordinator.

              </p>


            </div>

            <div class="uk-visible@m">
              <img src="../assets/girls_studying.jpg" alt="">
            </div>


          </div>
          <div class="uk-child-1-1@m" uk-grid>
            <div>
              <p class="uk-margin-remove-top">
                All online students have access to the same quality of
                teaching as campus-based students and all our facilitators have gone through rigorous training
                to guarantee that you will receive superior quality course delivery to keep you motivated and
                on track. We are committed to providing an incomparable and distinctive learning experience
                for all students.

                Northern Caribbean University is committed to excellence in digital education and your
                qualification is accredited by the University Council of Jamaica (UCJ) and the Adventist
                Accreditation Association (AAA). Let us at Northern Caribbean University, Digital Education
                help you to realize your academic goals and dreams; apply today.
              </p>
            </div>
          </div>


        </div>
      </div>
      <div class="uk-padding uk-background-secondary">
        <div class="uk-container uk-container-large">
          <h2 class="uk-heading-line uk-text-center specHeading uk-light">Advantages of Digital Education </h2>
          <br>
          <div class=" uk-child-width-1-3@m uk-child-width-1-5@l uk-light" uk-grid>

            <div>
              <dl class="uk-description-list uk-description-list-divider ">
                <dt><b class="uk-light" style="color: rgb(197,179,88) !important;">You can learn whatever you want!</b></dt>
                <dd>You can pick the program of your dreams in traditional education, too, but that would involve
                  traveling away from home, living in a completely unknown city, and struggling in an extremely
                  competitive learning environment. With digital education, you can take any program or course
                  present in traditional four-year universities.</dd>
              </dl>
            </div>
            <div>
              <dl class="uk-description-list uk-description-list-divider ">
                <dt><b class="uk-light" style="color: rgb(197,179,88) !important;">Comfort.</b></dt>
                <dd>Forget about attending classes for hours, sitting in an uncomfortable chair, and suffering from
                  back pain by the end of the day. You will not be bound to physical class session when you opt
                  for digital education. All lectures and needed materials are provided via online platforms, so
                  you’ll easily access them from the comfort of your home.</dd>
              </dl>
            </div>
            <div>
              <dl class="uk-description-list uk-description-list-divider ">
                <dt><b class="uk-light" style="color: rgb(197,179,88) !important;">Online courses look great on a resume.</b></dt>
                <dd>It doesn’t matter where your career stands at this moment; an online program will always look
                  good on your resume. It will show potential employers that you’re committed to learning and
                  you’re eager to obtain more knowledge and new skills.</dd>

              </dl>
            </div>
            <div>

              <dl class="uk-description-list uk-description-list-divider ">


                <dt><b class="uk-light" style="color: rgb(197,179,88) !important;">Self-paced learning.</b></dt>
                <dd>When you start browsing through interesting online courses and programs, you’ll notice the
                  Self-Paced label on most of them. What does this mean? Self-paced learning means that the
                  students can start completing the targets at any time, and he can arrange a learning schedule
                  that meets his individual needs.</dd>
              </dl>
            </div>
            <div>
              <dl class="uk-description-list uk-description-list-divider ">
                <dt ><b class="uk-light" style="color: rgb(197,179,88) !important;">Lower costs.</b></dt>
                <dd>The fact that online programs are cheaper when compared to the ones held in a traditional
                  campus setting is enough to convince you to consider them. The average tuition for online
                  courses depends on multiple factors, so it varies from one program to another.</dd>
              </dl>

            </div>

        </div>
      </div>

      </div>
      <div class="uk-padding">

        <div class="uk-container uk-container-small">
          <h2 class="uk-heading-bullet specHeading "><span>What are the benefits of being an online student?</span></h2>
          <div class="uk-child-width-1-2@m" uk-grid>
            <div>
              <p class=" ">
                Studying through Digital Education at Northern Caribbean University offers the option of
                receiving a Christ-centred education that allows you to fit it around work, social lifestyle and
                family commitments. The convenience of achieving your personal and professional goals
                without having to leave your job, geographical location, friends and family to attend classes on
                campus.  

                One third (1/3) of the contact hours will be delivered synchronously and the
                remainder will be delivered asynchronously, which will allow you to study at your own pace.
                The Digital Education team will ensure that you receive full support from the system, your
                facilitator and the course coordinator.
              </p>

            </div>

            <div class="uk-visible@m">
              <img src="../assets/coned12.jpg" alt="">
            </div>

          </div>

          <div class="uk-uk-child-width-1-1@m">
            <p class="">
              <br>
              Northern Caribbean University is committed to excellence in digital education and your
              qualification is accredited by the University Council of Jamaica (UCJ) and the Adventist
              Accreditation Association (AAA). Let us at Northern Caribbean University, Digital Education
              help you to realize your academic goals and dreams; apply today.
              All online students have access to the same quality of
              teaching as campus-based students and all our facilitators have gone through rigorous training
              to guarantee that you will receive superior quality course delivery to keep you motivated and
              on track.  We are committed to providing an incomparable and distinctive learning experience
              for all students.
            </p>
          </div>




        </div>


      </div>

    </div>
  </transition>
</template>

<script>
    export default {
        name: "onlinestudent",
      mounted(){
        window.scrollTo(0, 0);
      },
      metaInfo: {
        // Children can override the title.
        title: 'NCU Online Students',
        // Result: My Page Title ← My Site
        // If a child changes the title to "My Other Page Title",
        // it will become: My Other Page Title ← My Site
        //titleTemplate: '%s ← My Site',
        // Define meta tags here.
        meta: [
          {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
          {name: 'viewport', content: 'width=device-width, initial-scale=1'},
          {name: 'description', content: 'Online students engagement for Northern Caribbean University '}
        ]
      }
    }
</script>

<style scoped>
  @media screen and (max-width:600px){

    h2{
      font-size: 1.1em !important;
    }
    h1{
      font-size: large !important;
    }
    p,li{
      font-size: 0.8em !important;
    }


  }
</style>
